<template>
  <div
    class="control-cart"
    @mouseenter="showDropdownCart"
    @mouseleave="hideDropdownCart"
  >
    <div
      class="control-cart__wrap"
      @click="toCheckout"
    >
      <div class="icon">
        <f-sprite-icon :icon-link="$options.icons.IconCart.id" />
        <ui-badge
          :loading="UPDATE_PROGRESS"
          :text="PRODUCT_COUNT"
          max-width="50"
        />
      </div>
      <div class="control-cart__amount" v-if="amount">
        <span>Сумма</span>
        <div
          class="price-rub"
          v-text="$options.filters.price(amount)"
        />
      </div>
    </div>

    <div class="dropdown">
      <ui-dropdown
        :visible="cartVisible"
        overlay-height="40"
        right
      >
        <template v-if="PRODUCTS.length">
          <cart-item
            v-for="p in PRODUCTS"
            :key="p.lineIds[0]"
            :product="p"
          />
          <ui-button wide large text="Оформить заказ" slot="footer" @click="toCheckout" />
        </template>
        <template v-else>
          <page-info subtitle="В корзине пока нет добавленных товаров" />
        </template>
      </ui-dropdown>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import CartItem from './cart-item.vue';
import PageInfo from '../common/page-info.vue';

/* Icons */
import IconCart from '../../assets/icons/cart.svg';

export default {
  name: 'control-cart',
  components: {
    CartItem,
    PageInfo,
  },

  inject: ['adaptive'],

  icons: {
    IconCart,
  },

  data: () => ({
    cartVisible: false,
  }),

  computed: {
    ...mapGetters({
      PRODUCT_COUNT: 'cart/productCount',
      SUBTOTAL: 'cart/subtotal',
      PRODUCTS: 'cart/products',
      UPDATE_PROGRESS: 'cart/updateProgress',
    }),

    amount() {
      return parseInt(this.SUBTOTAL);
    },
  },

  mounted () {
    !this.PRODUCTS.length && this.LOAD_CART();
  },

  methods: {
    ...mapActions({
      LOAD_CART: 'cart/loadCart',
    }),

    toCheckout() {
      location = '/checkout';
    },

    showDropdownCart() {
      if (this.adaptive.isDesktop) this.cartVisible = true;
    },

    hideDropdownCart() {
      if (this.adaptive.isDesktop) this.cartVisible = false;
    }
  },
}
</script>

<style lang="scss">
.control-cart {
  &__wrap {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
  }

  &__amount,
  &__dropdown {
    display: none;
  }
}

@include breakpoint("desktop") {
  .control-cart {
    &__amount {
      display: block;
      font-size: 16px;
      line-height: 24px;
      margin: -8px 0 -8px 20px;

      span {
        font-size: 14px;
        line-height: 16px;
        display: block;
        color: $gray;
      }
    }

    .ui-dropdown {
      width: 360px;
    }

    .page-info {
      margin: 0;
      padding: 40px;
    }
  }
}

</style>
